// 九鼎-摄像头组件

import React, { useState, useEffect } from 'react'
import publicApi from "@api/public";

const JDVideoHook = () => {

  const [websocket, setWebSocket] = useState(null);
  const [playerDoms, setPlayerDoms] = useState({});
  const [testWebSocket, setTestWebSocket] = useState({});
  const [playerList, setPlayerList] = useState([]);

  useEffect(() => {
    return () => {
      closeWebSocket();
      disposePlayerDoms();
    };
  }, []);

  // 关闭websocket
  const closeWebSocket = () => {
    let playerWebSocket = testWebSocket.playerWebSocket;
    playerWebSocket && playerWebSocket.close();
  };
  // 初始化链接websocket
  const initWebSocket = () => {
    let url = window.globalConfig.WEBSCOKETURL;
    let ws = new WebSocket(url);
    ws.onopen = () => {
      //setInterval(() => {
      //ws.send(param)
      // }, 60 * 1000)
      setWebSocket(ws);
    };
  };
  // 视频在关闭以后，必须销毁,不然视频存在内存中，不会再次被初始化
  const disposePlayerDoms = () => {
    playerList.length &&
      playerList.map((item) => {
        let player = window.videojs(`my-player${item.cameraId}`);
        if (player) {
          player.dispose();
          playerDoms[`playerDom${item.cameraId}`] = null;
          setPlayerDoms(playerDoms);
        }
      });
  };

  // 播放
  const getPlayerDom = (playerList) => {
    setPlayerList(playerList);
    if (playerList.length > 0) {
      playerList.map((item) => {
        publicApi.play(item).then((res) => {
          if (res.status == 0) {
            let dom = document.getElementById(`my-player${item.cameraId}`);
            if (dom && websocket) {
              websocket.onmessage = (evt) => {
                //绑定收到消息事件
                let data = JSON.parse(evt.data);
                if (data.status == 0) {
                  let { cameraId, hlsUrl, rtmpUrl } = data.data;
                  playerList.map((mm) => {
                    if (mm.cameraId == cameraId) {
                      let videoDom = playerDoms[`playerDom${cameraId}`]
                        ? playerDoms[`playerDom${cameraId}`]
                        : window.videojs(`my-player${cameraId}`);
                      if (videoDom && videoDom.player_) {
                        videoDom.src({
                          type: "application/x-mpegURL",
                          src: hlsUrl,
                        });
                        testWebSocket[`playerWebSocket`] = websocket;
                        setTestWebSocket(testWebSocket);
                        playerDoms[`playerDom${cameraId}`] = videoDom;
                        setPlayerDoms(playerDoms);
                      }
                    }
                  })
                }
              };
            }
          }
        });
      });
    }
  };

  return {
    initWebSocket,
    getPlayerDom,
    disposePlayerDoms,
    websocket,
  }
}
export default JDVideoHook